const sv = {
  translation: {
    menu: "Meny",
    languageNames: {
      english: "Engelska",
      swedish: "Svenska",
    },
    chooseLanguage: "Välj Språk",
    topStory: "Dagens Toppnyheter",
    password: "Lösenord",
    confirmPassword: "Bekräfta lösenord",
    submit: "Skicka in",
    registrationSuccessful: "Registrering lyckad",
    signUp: "Registrera",
    signIn: "Logga In",
    categories: "Sektioner",
    signInMessage: "Inloggning lyckad",
    subscribed: "Prenumerera nu",
    becomeASubscriber: "Bli prenumerant för endast 199 kr per år."
  },
};
export default sv;
